import { Injectable, OnDestroy } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { HubConnectionState } from "@microsoft/signalr";
import { Store } from "@ngxs/store";
import { Subject } from "rxjs/internal/Subject";
import { environment } from "src/environments/environment";
import { AuthState } from "../states/auth/auth.state";
import { SetBulkVerifyLoadedPercent } from "../states/transactions/transactions.actions";
import { TransactionsService } from "./transactions.service";
import { PharmacyState } from "../states/pharmacy/pharmacy.state";

@Injectable()

export class BulkVerifyHubService implements OnDestroy {
    private interval: any;

    public bulkVerifyInitiated$ = new Subject();
    
    constructor(private store: Store, private transactionsService: TransactionsService) {}

       public startListening(): void {
        this.startConnection();
        this.registerListener();
      
        this.interval = setInterval(() => {
          if(this.hubConnection?.state === HubConnectionState.Disconnected || this.hubConnection?.state === HubConnectionState.Disconnecting) {
            setTimeout(() => {
              this.startConnection();
             this.registerListener();
            });
          }
        }, 1000);
       }
    
      private hubConnection: signalR.HubConnection;
    
        private startConnection = () => {
          const signalRApiHost = environment.signalRApiHost;
    
          this.hubConnection = new signalR.HubConnectionBuilder()
                                  .withUrl(`${signalRApiHost}/pending-transactions/bulk-verify?pharmacyId=${this.store.selectSnapshot(PharmacyState.currentPharmacy)?.id}`, {
                                    skipNegotiation: true,
                                    transport: signalR.HttpTransportType.WebSockets,
                                    withCredentials: true,
                                    accessTokenFactory: () => this.store.selectSnapshot(AuthState.bearerToken)
                                  })
                                  .build();
               
          this.hubConnection
            .start()
            .then(() => console.log('Bulk Verify Connection started'))
            .catch(err => console.log('Error while starting connection: ' + err));
        }
        
        private registerListener = () => {
            this.hubConnection.on('ReceiveLoadedPercent', (loadedPercent: number) => {
                this.store.dispatch(new SetBulkVerifyLoadedPercent(loadedPercent));
                this.transactionsService.refreshTransactionsTable$.next();
            });

            this.hubConnection.on('ProcessInitiated', (signer: any) => {
              this.bulkVerifyInitiated$.next(signer);
            });
        }
    
       ngOnDestroy(): void {
        setTimeout(() => {
          clearInterval(this.interval);
          this.hubConnection?.stop(); 
        });
       }

       public isConnected(): boolean {
        return this.hubConnection?.state && this.hubConnection.state !== HubConnectionState.Disconnected;
       }

}